var $c66b48b42be7e11a$exports = {};
$c66b48b42be7e11a$exports = {
    "(optional)": `(optioneel)`,
    "(required)": `(vereist)`
};


export {$c66b48b42be7e11a$exports as default};
//# sourceMappingURL=nl-NL.mjs.map
